import React from 'react';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import config from '../configs';

function EasylinkModalTitle({ offer, wasAlreadyLinked }) {
  const { displayRate, currency, rclonMerchantName } = offer;
  const { wasLinkedInstoreLabel, justLinkedInstoreLabel } = config;

  if (wasAlreadyLinked) {
    return (
      <SectionTitle
        id="mn_dialogTitle"
        title={
          <>
            Good news!
            <br />
            You're ready to earn {displayRate} {currency}
            {' '}
            <span className="mn_noWrap">{wasLinkedInstoreLabel}</span> at {rclonMerchantName}
            {' '}
            <span className="mn_dot">.</span>
          </>
        }
      />
    );
  }

  const formattedMerchantName = rclonMerchantName.endsWith('s') ? `${rclonMerchantName}'` : `${rclonMerchantName}'s`;

  return (
    <SectionTitle
      id="mn_dialogTitle"
      title={
        <>
          Good news!
          <br />
          We've linked your participating card(s)
          to {formattedMerchantName} <span className="mn_noWrap">{justLinkedInstoreLabel}</span> offers
          {' '}
          <span className="mn_dot">.</span>
        </>
      }
    />
  );
}

export default (props) => <ComponentErrorBoundary><EasylinkModalTitle {...props} /></ComponentErrorBoundary>;
